"use client"

import "firebase/compat/firestore"
import "firebase/compat/database"
import React, { useEffect, useState, useRef } from "react"
import "./LeftNav.css"
import firebase from "firebase/compat/app"
import "firebase/compat/auth"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  faTachometerAlt,
  faVideo,
  faMicrophone,
  faMicrophoneSlash,
  faVideoCamera,
  faVideoSlash,
  faPhoneSlash,
  faExpand,
  faCompress,
  faUsers,
  faBars,
  faTimes,
  faCopy,
  faCheck,
} from "@fortawesome/free-solid-svg-icons"
import logo from "../components/logo.png"
import brand from "../components/logo-two.png"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"
import MeetingHistory from "./MeetingHistory"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import "./feedback.css"

const LeftNav = () => {
  const [localStream, setLocalStream] = useState(null)
  const [remoteStream, setRemoteStream] = useState(null)
  const [pc, setPC] = useState(null)
  const [callInputValue, setCallInputValue] = useState("")
  const [initialized, setInitialized] = useState(false)
  const [firestore, setFirestore] = useState(null)
  const [database, setDatabase] = useState(null)
  const [callLink, setCallLink] = useState("")
  const [showVideoSection, setShowVideoSection] = useState(false)
  const [showThankYouMessage, setShowThankYouMessage] = useState(false)
  const [isMicEnabled, setIsMicEnabled] = useState(true)
  const [isVideoEnabled, setIsVideoEnabled] = useState(true)
  const [isCallActive, setIsCallActive] = useState(false)
  const [isRemoteVideoVisible, setIsRemoteVideoVisible] = useState(false)
  const [view, setView] = useState("dashboard")
  const [historyUser, setHistoryUser] = useState(null)
  const [callEnded, setCallEnded] = useState(false)
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [showControls, setShowControls] = useState(true)
  const [controlsTimeout, setControlsTimeout] = useState(null)
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [linkCopied, setLinkCopied] = useState(false)

  const webcamVideoRef = useRef(null)
  const remoteVideoRef = useRef(null)
  const videoContainerRef = useRef(null)
  const navigate = useNavigate()

  const [pendingUsers, setPendingUsers] = useState([])
  const token = useSelector((state) => state.user.currentUser.token)
  const user = useSelector((state) => state.user.currentUser)
  const userId = useSelector((state) => state.user.currentUser?.id)
  const [codeInputValue, setCodeInputValue] = useState("")
  const [rating, setRating] = useState(null)
  const [comments, setComments] = useState("")
  const [showFeedback, setShowFeedback] = useState(false)

  // Auto-hide controls in fullscreen
  useEffect(() => {
    if (isFullscreen) {
      const hideControls = () => {
        setShowControls(false)
      }

      const showControlsTemporarily = () => {
        setShowControls(true)
        if (controlsTimeout) clearTimeout(controlsTimeout)
        const timeout = setTimeout(hideControls, 3000)
        setControlsTimeout(timeout)
      }

      const handleMouseMove = () => showControlsTemporarily()

      document.addEventListener("mousemove", handleMouseMove)
      showControlsTemporarily()

      return () => {
        document.removeEventListener("mousemove", handleMouseMove)
        if (controlsTimeout) clearTimeout(controlsTimeout)
      }
    } else {
      setShowControls(true)
      if (controlsTimeout) clearTimeout(controlsTimeout)
    }
  }, [isFullscreen, controlsTimeout])

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      videoContainerRef.current?.requestFullscreen()
      setIsFullscreen(true)
    } else {
      document.exitFullscreen()
      setIsFullscreen(false)
    }
  }

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen)
  }

  const handleCopyLink = async () => {
    if (!callLink) {
      toast.error("No link to copy. Please create a link first.")
      return
    }

    try {
      await navigator.clipboard.writeText(callLink)
      setLinkCopied(true)
      toast.success("Link copied to clipboard!")
      setTimeout(() => setLinkCopied(false), 2000)
    } catch (error) {
      console.error("Failed to copy link:", error)
      toast.error("Failed to copy link.")
    }
  }

  const handleShareLink = async () => {
    if (!callLink || !codeInputValue) {
      toast.error("Please provide both a call link and a code before sharing.")
      return
    }
    try {
      const response = await fetch(`${process.env.REACT_APP_ORIGIN_URL}/get-code`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          link: callLink,
          code: codeInputValue,
        }),
      })
      if (!response.ok) {
        throw new Error(`Failed to share link via get-code API: ${response.statusText}`)
      }
      const data = await response.json()
      console.log("get-code API response:", data)
      toast.success("Call link shared to the patient.")
    } catch (error) {
      console.error("Error sharing link via get-code API:", error)
      toast.error("Failed to share link. Please try again.")
    }
  }

  useEffect(() => {
    if (firestore) {
      const unsubscribe = firestore.collection("calls").onSnapshot((snapshot) => {
        const newPendingUsers = snapshot.docs
          .map((doc) => {
            const data = doc.data()
            console.log(`Pending user ${doc.id}:`, data)
            return {
              id: doc.id,
              ...data,
            }
          })
          .filter((user) => user.status === "pending")
        setPendingUsers(newPendingUsers)
      })
      return () => unsubscribe()
    }
  }, [firestore])

  useEffect(() => {
    if (firestore && callInputValue) {
      const callDoc = firestore.collection("calls").doc(callInputValue)
      const unsubscribe = callDoc.onSnapshot((snapshot) => {
        const callData = snapshot.data()
        if (callData && callData.status === "ended" && !callEnded) {
          console.log("Call ended detected via Firestore listener")
          endCallCleanup()
        } else if (callData && callData.status === "accepted") {
          setIsRemoteVideoVisible(true)
          if (remoteStream && remoteVideoRef.current) {
            remoteVideoRef.current.srcObject = remoteStream
            remoteVideoRef.current.play().catch((error) => {
              console.error("Error playing remote video:", error)
            })
          }
          // Show toast when call is accepted
          // toast.success("Call connected! You are now in consultation with the patient.", {
          //   position: "top-center",
          //   autoClose: 5000,
          // })
        }
      })
      return () => unsubscribe()
    }
  }, [firestore, callInputValue, callEnded, remoteStream])

  const handleJoinCall = async (callId, participantName) => {
    console.log("handleJoinCall called with:", { callId, participantName })
    const userDoc = firestore.collection("users").doc(userId.toString())
    const meetingHistoryDoc = userDoc.collection("meetingHistory").doc(callId)
    try {
      const userRef = database.ref(`users/${callId}`)
      await userRef.update({
        status: "accepted",
        startTime: firebase.database.ServerValue.TIMESTAMP,
      })
      const callDoc = firestore.collection("calls").doc(callId)
      await callDoc.update({
        status: "accepted",
        startTime: firebase.firestore.FieldValue.serverTimestamp(),
      })
      console.log("Updating participant meeting history for user:", userId, "with participantName:", participantName)
      await meetingHistoryDoc.set(
        {
          callId: callId,
          participantName: participantName || "Unknown",
          startTime: firebase.firestore.FieldValue.serverTimestamp(),
          status: "ongoing",
          date: new Date().toISOString().split("T")[0],
        },
        { merge: true },
      )
      console.log("Participant meeting history updated successfully")
      const callSnapshot = await callDoc.get()
      const callData = callSnapshot.data()
      const creatorUserId = callData?.creatorUserId
      console.log("Creator userId from calls doc:", creatorUserId)
      if (creatorUserId && creatorUserId !== String(userId)) {
        const creatorDoc = firestore.collection("users").doc(creatorUserId)
        const creatorMeetingHistoryDoc = creatorDoc.collection("meetingHistory").doc(callId)
        await creatorMeetingHistoryDoc.set(
          {
            callId: callId,
            participantName: participantName || "Unknown",
            startTime: firebase.firestore.FieldValue.serverTimestamp(),
            status: "ongoing",
            date: new Date().toISOString().split("T")[0],
          },
          { merge: true },
        )
        console.log("Creator meeting history updated successfully")
      } else {
        console.log("No creatorUserId or same as current user, skipping creator update")
      }
      setIsCallActive(true)
      setIsRemoteVideoVisible(true)
      setHistoryUser(participantName)
      setPendingUsers((prev) => prev.filter((u) => u.id !== callId))
      setSidebarOpen(false) // Close sidebar when call starts
    } catch (error) {
      console.error("Error joining the call:", error)
      toast.error("Failed to join the call. Please try again.")
    }
  }

  const [waitingTimes, setWaitingTimes] = useState({})
  const calculateWaitingTime = (timestamp) => {
    if (timestamp instanceof firebase.firestore.Timestamp) {
      const enteredTime = timestamp.toDate()
      const now = new Date()
      const differenceInSeconds = Math.floor((now - enteredTime) / 1000)
      const minutes = Math.floor(differenceInSeconds / 60)
      const seconds = differenceInSeconds % 60
      return `${minutes > 0 ? `${minutes}m ` : ""}${seconds}s`
    }
    return "N/A"
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setWaitingTimes((prev) => {
        const updatedWaitingTimes = {}
        pendingUsers.forEach((user) => {
          updatedWaitingTimes[user.id] = calculateWaitingTime(user.timestamp)
        })
        return updatedWaitingTimes
      })
    }, 1000)
    return () => clearInterval(interval)
  }, [pendingUsers])

  useEffect(() => {
    const initializeFirebase = () => {
      const firebaseConfig = {
        apiKey: "AIzaSyBDXL7mezxWb1nEjYpTmiDnmsS-7GYykLo",
        authDomain: "ejamica-call.firebaseapp.com",
        databaseURL: "https://ejamica-call-default-rtdb.firebaseio.com",
        projectId: "ejamica-call",
        storageBucket: "ejamica-call.firebasestorage.app",
        messagingSenderId: "56137661542",
        appId: "1:56137661542:web:190294cc6da5fce7f5c1a7",
      }
      if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig)
      }
      const db = firebase.firestore()
      setFirestore(db)
      setDatabase(firebase.database())
      setInitialized(true)
      db.collection("test")
        .doc("connection")
        .set({
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          message: "Test connection from LeftNav",
        })
        .then(() => console.log("Firestore test write successful"))
        .catch((error) => console.error("Firestore test write failed:", error))
    }
    initializeFirebase()
  }, [])

  const handleLogout = () => {
    localStorage.removeItem("token")
    navigate("/")
    toast.info("Logged out successfully.")
  }

  const handleWebcamButtonClick = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: { echoCancellation: true, noiseSuppression: true },
      })
      setLocalStream(stream)
      setShowVideoSection(true)
      const newPC = new RTCPeerConnection({
        iceServers: [
          { urls: "stun:stun1.l.google.com:19302" },
          { urls: "stun:stun2.l.google.com:19302" },
          {
            urls: "turn:turn.example.com:3478",
            username: "your-username",
            credential: "your-password",
          },
        ],
        iceCandidatePoolSize: 10,
      })
      newPC.ontrack = (event) => {
        if (event.streams && event.streams[0]) {
          console.log("Host: Remote stream received from participant")
          setRemoteStream(event.streams[0])
          if (remoteVideoRef.current) {
            remoteVideoRef.current.srcObject = event.streams[0]
            remoteVideoRef.current.play().catch((error) => console.error("Host: Error playing remote video:", error))
          }
        }
      }
      newPC.oniceconnectionstatechange = () => {
        console.log("Host: ICE connection state:", newPC.iceConnectionState)
        if (newPC.iceConnectionState === "failed") {
          // toast.error("Connection failed. Please try again.");
        }
      }
      stream.getTracks().forEach((track) => newPC.addTrack(track, stream))
      setPC(newPC)
      console.log("Host: Webcam and PeerConnection initialized")
    } catch (error) {
      console.error("Host: Error enabling camera:", error)
      // toast.error("Failed to enable camera. Check permissions or network.");
    }
  }

  const handleToggleMic = () => {
    if (localStream) {
      const audioTrack = localStream.getAudioTracks()[0]
      if (audioTrack) {
        audioTrack.enabled = !audioTrack.enabled
        setIsMicEnabled(audioTrack.enabled)
        toast.info(audioTrack.enabled ? "Microphone enabled." : "Microphone disabled.")
      }
    }
  }

  const handleToggleVideo = () => {
    if (localStream) {
      const videoTrack = localStream.getVideoTracks()[0]
      if (videoTrack) {
        videoTrack.enabled = !videoTrack.enabled
        setIsVideoEnabled(videoTrack.enabled)
        toast.info(videoTrack.enabled ? "Video enabled." : "Video disabled.")
      }
    }
  }

  const handleCallButtonClick = async () => {
    try {
      if (!codeInputValue) {
        toast.error("Please enter a code before creating a call link.")
        return
      }
      if (!firestore) throw new Error("Firestore is not initialized")
      if (!localStream) throw new Error("Please enable your camera before creating a link")
      if (!userId) throw new Error("User ID is not available")
      const callDoc = firestore.collection("calls").doc()
      const offerCandidates = callDoc.collection("offerCandidates")
      const answerCandidates = callDoc.collection("answerCandidates")
      setCallInputValue(callDoc.id)
      pc.onicecandidate = (event) => {
        if (event.candidate) {
          offerCandidates.add(event.candidate.toJSON())
          console.log("Host: Added offer ICE candidate:", event.candidate)
        }
      }
      const senders = pc.getSenders()
      const tracks = localStream.getTracks()
      tracks.forEach((track) => {
        const hasSender = senders.some((sender) => sender.track === track)
        if (!hasSender) {
          pc.addTrack(track, localStream)
          console.log("Host: Added track to PeerConnection:", track)
        }
      })
      const offerDescription = await pc.createOffer()
      await pc.setLocalDescription(offerDescription)
      console.log("Host: Offer created and set locally")
      await callDoc.set({
        offer: { sdp: offerDescription.sdp, type: offerDescription.type },
        status: "created",
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        startTime: firebase.firestore.FieldValue.serverTimestamp(),
        creatorUserId: String(userId),
      })
      const userDoc = firestore.collection("users").doc(String(userId))
      const meetingHistoryDoc = userDoc.collection("meetingHistory").doc(callDoc.id)
      await meetingHistoryDoc.set({
        callId: callDoc.id,
        participantName: "Pending",
        startTime: firebase.firestore.FieldValue.serverTimestamp(),
        status: "ongoing",
        date: new Date().toISOString().split("T")[0],
      })
      let hasSetRemoteDescription = false
      const unsubscribe = callDoc.onSnapshot((snapshot) => {
        const data = snapshot.data()
        if (!data || hasSetRemoteDescription || pc.signalingState === "closed") return
        if (data.answer && pc.signalingState === "have-local-offer") {
          pc.setRemoteDescription(new RTCSessionDescription(data.answer))
            .then(() => {
              hasSetRemoteDescription = true
              console.log("Host: Remote answer set successfully")
              unsubscribe()
            })
            .catch((error) => console.error("Host: Error setting remote description:", error))
        }
      })
      answerCandidates.onSnapshot((snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            const candidate = new RTCIceCandidate(change.doc.data())
            pc.addIceCandidate(candidate)
              .then(() => console.log("Host: Added answer ICE candidate"))
              .catch((error) => console.error("Host: Error adding answer ICE candidate:", error))
          }
        })
      })
     const callLink = `https://telemedicine.ehealthjm.com/call/${callDoc.id}`
      setCallLink(callLink)
      toast.success("Call link created successfully.")
    } catch (error) {
      console.error("Host: Error in handleCallButtonClick:", error)
      toast.error(error.message || "Failed to create call link.")
    }
  }

  const sendBillAPI = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_ORIGIN_URL}/send_bill`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          event_code: codeInputValue,
        }),
      })
      if (!response.ok) {
        throw new Error(`Failed to send bill: ${response.statusText}`)
      }
      const data = await response.json()
      console.log("send_bill API response:", data)
    } catch (error) {
      console.error("Error sending bill:", error)
    }
  }

  useEffect(() => {
    let interval
    if (isCallActive && codeInputValue) {
      sendBillAPI()
      interval = setInterval(() => {
        sendBillAPI()
      }, 60000)
    }
    return () => clearInterval(interval)
  }, [isCallActive, codeInputValue])

  useEffect(() => {
    if (localStream && webcamVideoRef.current) {
      webcamVideoRef.current.srcObject = localStream
      webcamVideoRef.current.play().catch((error) => {
        console.error("Error playing local video:", error)
      })
    }
  }, [localStream, isRemoteVideoVisible])

  const endCallCleanup = () => {
    if (pc) {
      pc.close()
      setPC(null)
    }
    if (localStream) {
      localStream.getTracks().forEach((track) => track.stop())
      setLocalStream(null)
    }
    setRemoteStream(null)
    setShowVideoSection(false)
    setShowThankYouMessage(false)
    setIsCallActive(false)
    setIsRemoteVideoVisible(false)
    setCallEnded(true)
    setShowFeedback(true)
    setIsFullscreen(false)
    if (webcamVideoRef.current) webcamVideoRef.current.srcObject = null
    if (remoteVideoRef.current) remoteVideoRef.current.srcObject = null
  }

  const handleHangupButtonClick = async () => {
    if (!pc || !firestore || !callInputValue) {
      console.warn("Cannot hang up: Missing peer connection, Firestore, or call ID.")
      return
    }
    const callDoc = firestore.collection("calls").doc(callInputValue)
    const userDoc = firestore.collection("users").doc(userId.toString())
    const meetingHistoryDoc = userDoc.collection("meetingHistory").doc(callInputValue)
    try {
      const endTime = firebase.firestore.FieldValue.serverTimestamp()
      const callSnapshot = await callDoc.get()
      if (!callSnapshot.exists) {
        console.warn("Call document does not exist for callInputValue:", callInputValue)
        await callDoc.set({
          status: "ended",
          endTime: endTime,
          timestamp: firebase.firestore.FieldValue.serverTimestamp(),
          linkExpired: true,
        })
      } else {
        const callData = callSnapshot.data()
        let duration = "0m 0s"
        if (callData.startTime && callData.startTime instanceof firebase.firestore.Timestamp) {
          const startTime = callData.startTime.toDate()
          const now = new Date()
          const durationInSeconds = Math.floor((now - startTime) / 1000)
          const minutes = Math.floor(durationInSeconds / 60)
          const seconds = durationInSeconds % 60
          duration = `${minutes}m ${seconds}s`
        }
        await callDoc.update({
          status: "ended",
          endTime: endTime,
          duration: duration,
        })
      }
      const meetingHistorySnapshot = await meetingHistoryDoc.get()
      const meetingData = meetingHistorySnapshot.exists ? meetingHistorySnapshot.data() : {}
      await meetingHistoryDoc.set(
        {
          callId: callInputValue,
          participantName: meetingData.participantName || "Unknown",
          endTime: endTime,
          duration: meetingData.duration || "0m 0s",
          status: "ended",
          date: meetingData.date || new Date().toISOString().split("T")[0],
        },
        { merge: true },
      )
      endCallCleanup()
      toast.success("Call ended successfully.")
    } catch (error) {
      console.error("Error ending the call:", error)
      endCallCleanup()
    }
  }

  const [updateKey, setUpdateKey] = useState(0)
  const forceUpdate = () => setUpdateKey((prevKey) => prevKey + 1)

  useEffect(() => {
    if (remoteStream && remoteVideoRef.current) {
      remoteVideoRef.current.srcObject = remoteStream
      remoteVideoRef.current.play().catch((error) => {
        console.error("Error playing remote video:", error)
      })
    }
  }, [remoteStream])

  const handleRatingChange = (value) => {
    setRating(value)
  }

  const handleFeedbackSubmit = async (e) => {
    e.preventDefault()
    if (!rating) {
      toast.error("Please provide a rating before submitting.")
      return
    }
    try {
      const payload = {
        link: callLink,
        patient_rating: rating,
        comments: comments,
      }
      const response = await fetch(`${process.env.REACT_APP_ORIGIN_URL}/ratings`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      })
      if (!response.ok) {
        throw new Error(`Failed to submit feedback: ${response.statusText}`)
      }
      const data = await response.json()
      console.log("Feedback API response:", data)
      toast.success("Thank you for your feedback!")
      setShowFeedback(false)
      setRating(null)
      setComments("")
      setTimeout(() => navigate("/"), 2000)
    } catch (error) {
      console.error("Error submitting feedback to ratings API:", error)
    }
  }

  const handleFeedbackCancel = () => {
    setShowFeedback(false)
    setRating(null)
    setComments("")
    setTimeout(() => navigate("/"), 2000)
  }

  const renderFeedbackForm = () => (
    <div className="container-fluid d-flex justify-content-center align-items-center bg-image vh-100">
      <div className="form-container feedback-form">
        <div className="logo mb-4 text-center">
          <img src={logo || "/placeholder.svg"} alt="eHealth Logo" style={{ maxHeight: "200px", width: "auto" }} />
        </div>
        <form onSubmit={handleFeedbackSubmit}>
          <div className="mb-3">
            <label htmlFor="rating" className="form-label">
              <strong>What rating would you like to give this patient</strong>
            </label>
            <div className="rate">
              {[1, 2, 3, 4, 5].map((value) => (
                <React.Fragment key={value}>
                  <input
                    type="radio"
                    id={`star${value}`}
                    name="rate"
                    value={value}
                    checked={rating === value}
                    onChange={() => handleRatingChange(value)}
                  />
                  <label htmlFor={`star${value}`} />
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="comments" className="form-label">
              <strong>Any suggestions to improve the platform</strong>
            </label>
            <textarea
              className="form-control"
              id="comments"
              rows="3"
              placeholder="Add your comments..."
              value={comments}
              onChange={(e) => setComments(e.target.value)}
            />
          </div>
          <div className="d-flex justify-content-end">
            <button type="button" className="btn btn-cancel" onClick={handleFeedbackCancel}>
              Cancel
            </button>
            <button type="submit" className="btn btn-submit">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  )

  const handleDeclineCall = async (callId) => {
    try {
      const firestore = firebase.firestore()
      const callDoc = firestore.collection("calls").doc(callId)
      await callDoc.update({
        status: "declined",
        endTime: firebase.firestore.FieldValue.serverTimestamp(),
      })
      toast.info("Call declined.")
      setPendingUsers((prev) => prev.filter((u) => u.id !== callId))
    } catch (error) {
      console.error("Error declining the call:", error)
    }
  }

  return (
    <div className="video-app">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="app-layout">
        {/* Mobile Menu Button */}
        <button className="mobile-menu-btn" onClick={toggleSidebar}>
          <FontAwesomeIcon icon={sidebarOpen ? faTimes : faBars} />
        </button>

        {/* Sidebar Overlay for Mobile */}
        {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

        {/* Left Sidebar */}
        <div className={`left-nav ${sidebarOpen ? "sidebar-open" : ""}`}>
          <div className="nav-header">
            <div className="logo-wrapper">
              <img className="logo-img" src={brand || "/placeholder.svg"} alt="Logo" />
            </div>
          </div>

          <div className="nav-content">
            <div className="nav-section">
              <h6 className="nav-section-title">
                <FontAwesomeIcon icon={faUsers} className="nav-icon" />
                <span className="nav-text">PATIENT QUEUE</span>
              </h6>

              {pendingUsers.length > 0 ? (
                <div className="pending-users-list">
                  {pendingUsers.map((user) =>
                    user.status !== "ended" ? (
                      <div
                        className="patient-card"
                        key={user.id}
                        data-initial={user.participantName ? user.participantName.charAt(0).toUpperCase() : "P"}
                      >
                        <div className="patient-info">
                          <div className="patient-name">{user.participantName}</div>
                          <div className="waiting-time">
                            Waiting {waitingTimes[user.id] || calculateWaitingTime(user.timestamp)}
                          </div>
                        </div>
                        <div className="patient-actions">
                          <button onClick={() => handleJoinCall(user.id, user.participantName)} className="btn-accept">
                            Accept
                          </button>
                          <button onClick={() => handleDeclineCall(user.id)} className="btn-decline">
                            Decline
                          </button>
                        </div>
                      </div>
                    ) : null,
                  )}
                </div>
              ) : (
                <div className="empty-queue">No patients in queue</div>
              )}
            </div>

            <div className="nav-section">
              <h6 className="nav-section-title">
                <span className="nav-text">GENERAL</span>
              </h6>

              <div className="nav-menu">
                <button
                  className={`nav-item ${view === "dashboard" ? "active" : ""}`}
                  onClick={() => {
                    setView("dashboard")
                    setSidebarOpen(false)
                  }}
                >
                  <FontAwesomeIcon icon={faTachometerAlt} className="nav-icon" />
                  <span className="nav-text">Dashboard</span>
                </button>

                <button
                  className={`nav-item ${view === "history" ? "active" : ""}`}
                  onClick={() => {
                    setView("history")
                    setSidebarOpen(false)
                  }}
                  disabled={isRemoteVideoVisible}
                >
                  <FontAwesomeIcon icon={faVideo} className="nav-icon" />
                  <span className="nav-text">Meeting History</span>
                </button>
              </div>
            </div>
          </div>

          <div className="nav-footer">
            <button className="logout-btn" onClick={handleLogout}>
              <span className="nav-text">Logout</span>
            </button>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content">
          {view === "history" && userId ? (
            <MeetingHistory userId={userId} />
          ) : view === "history" ? (
            <div className="loading">Loading user data...</div>
          ) : showFeedback ? (
            renderFeedbackForm()
          ) : (
            <>
              {/* Local Video (Picture-in-Picture) */}
              {/* <div className="local-video-pip">
                <video
                  ref={(ref) => {
                    if (ref) {
                      ref.srcObject = localStream
                    }
                  }}
                  className="local-video"
                  autoPlay
                  muted
                  playsInline
                />
                <div className="pip-label">You</div>
              </div> */}
              {/*  */}
              {isRemoteVideoVisible ? (
                <div className={`video-call-container ${isFullscreen ? "fullscreen" : ""}`} ref={videoContainerRef}>
                  {/* Remote Video (Main) */}
                  <div className="remote-video-container">
                    <video ref={remoteVideoRef} className="remote-video" autoPlay playsInline />

                    {/* Local Video (Picture-in-Picture) */}
                    <div className="local-video-pip">
                      <video ref={webcamVideoRef} className="local-video" autoPlay muted playsInline />
                    </div>

                    {/* Video Controls */}
                    <div className={`video-controls ${showControls ? "visible" : "visible"}`}>
                      <div className="controls-group">
                        <button
                          className={`control-btn ${isMicEnabled ? "active" : "inactive"}`}
                          onClick={handleToggleMic}
                          title={isMicEnabled ? "Mute" : "Unmute"}
                        >
                          <FontAwesomeIcon icon={isMicEnabled ? faMicrophone : faMicrophoneSlash} />
                        </button>

                        <button
                          className={`control-btn ${isVideoEnabled ? "active" : "inactive"}`}
                          onClick={handleToggleVideo}
                          title={isVideoEnabled ? "Turn off camera" : "Turn on camera"}
                        >
                          <FontAwesomeIcon icon={isVideoEnabled ? faVideoCamera : faVideoSlash} />
                        </button>

                        <button className="control-btn end-call" onClick={handleHangupButtonClick} title="End call">
                          <FontAwesomeIcon icon={faPhoneSlash} />
                        </button>

                        <button
                          className="control-btn"
                          onClick={toggleFullscreen}
                          title={isFullscreen ? "Exit fullscreen" : "Fullscreen"}
                        >
                          <FontAwesomeIcon icon={isFullscreen ? faCompress : faExpand} />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                /* Dashboard View */
                <div className="dashboard">
                  {/* <div className="dashboard-header">
                    <h1>Welcome, Doctor!</h1>
                    <p>Manage your video consultations and patient queue</p>
                  </div> */}

                  <div className="dashboard-content">
                    <div className="setup-panel">
                      <div className="setup-card">
                        <h3>Welcome, Doctor!</h3>
                        <p>Manage your video consultations and patient queue</p>

                        <div className="setup-form-two">
                          <div className="form-group-two">
                            <label>Patient Code</label>
                            <input
                              type="text"
                              value={codeInputValue}
                              onChange={(e) => setCodeInputValue(e.target.value)}
                              placeholder="Enter patient code..."
                              className="form-input"
                            />
                          </div>

                          <div className="form-group-two">
                            <label>Consultation Link</label>
                            <div className="link-input-group">
                              <input
                                value={callLink}
                                readOnly
                                placeholder="Call link will appear here..."
                                className="form-input link-input"
                              />
                              {/* <button
                                className="btn-copy-link"
                                onClick={handleCopyLink}
                                disabled={!callLink}
                                title="Copy link"
                              >
                                <FontAwesomeIcon icon={linkCopied ? faCheck : faCopy} />
                              </button> */}
                            </div>
                          </div>

                          <div className="form-actions">
                            <button className="btn-primary" onClick={handleCallButtonClick} disabled={!codeInputValue}>
                              Create Link
                            </button>
                            <button className="btn-secondary" onClick={handleShareLink} disabled={!callLink}>
                              Share Link
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="preview-panel">
                      <div className="camera-preview">
                        {showVideoSection ? (
                          <div className="video-preview">
                            <video ref={webcamVideoRef} className="preview-video" autoPlay muted playsInline />
                            <div className="preview-controls">
                              <button
                                className={`preview-control ${isMicEnabled ? "active" : "inactive"}`}
                                onClick={handleToggleMic}
                              >
                                <FontAwesomeIcon icon={isMicEnabled ? faMicrophone : faMicrophoneSlash} />
                              </button>
                              <button
                                className={`preview-control ${isVideoEnabled ? "active" : "inactive"}`}
                                onClick={handleToggleVideo}
                              >
                                <FontAwesomeIcon icon={isVideoEnabled ? faVideoCamera : faVideoSlash} />
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div className="camera-placeholder">
                            <div className="placeholder-content">
                              <FontAwesomeIcon icon={faVideoCamera} className="placeholder-icon" />
                              <h4>Camera Preview</h4>
                              <p>Enable your camera to start video consultations</p>
                              <button className="btn-primary" onClick={handleWebcamButtonClick}>
                                Enable Camera
                              </button>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default LeftNav
